import { render } from "./waveCanvas.vue?vue&type=template&id=617e3df4"
import script from "./waveCanvas.vue?vue&type=script&lang=js"
export * from "./waveCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__